var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedinDesktopLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 21,
  viewBox: "0 0 19 21",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9 0q1.5 0 2 1.5c.292.9 1.062 3.25 1.5 4q.438.75 3.5 4.5h3v10h-5q-4 1-5.23 1H4.822c-.877 0-1.9-.6-2.192-1.5-.146-.6-.146-1.05 0-1.5a2.25 2.25 0 0 1-1.9-2.25c0-.3.146-.75.292-1.05C.438 14.25 0 13.5 0 12.75c0-.6.146-1.05.585-1.5C.146 10.8 0 10.35 0 9.75 0 8.55 1.33 8 2.5 8h4Q6 4.9 6 4V2.5C6 1.5 7.27 0 9 0m.5 2.5C9 1.5 8.167 2 8 2.5S7.856 3.878 8 5q.145 1.122 1 5H3q-1 .5 0 1.5c-1 .5-1 1.5-.5 2l.107.107.893.893C3 15 2.707 15.511 3 16s1 1 2 1c-.5.5 0 1.5 0 1.5s.5.5 1 .5h4c.613 0 1.887-.335 2.5-.5L14 18h3v-6h-2q-1.76-2.07-2-2.5c-.24-.43-2-2.5-2.5-3.5s-.5-2.5-1-3.5"
})));
export default SvgLinkedinDesktopLike;